module.exports = __webpack_public_path__ + "img/img1.6bd7a94b.jpg";